const normalizeStatus = (value) => String(value || '').trim().toLowerCase();

const PAID_STATUSES = ['paid', 'done', 'cobrada', 'pagada'];
const CANCELED_STATUSES = ['canceled', 'cancelada', 'cancelado'];
const PARTIAL_STATUSES = ['partial', 'parcial', 'partially_paid', 'partially-paid', 'partial_paid', 'parcialmente pagada'];
const PENDING_STATUSES = ['pending', 'pendiente'];

export const resolveInvoiceStatusCategory = (row) => {
  const status = normalizeStatus(row?.status_key || row?.status);

  if (PAID_STATUSES.includes(status)) {
    return 'paid';
  }

  if (CANCELED_STATUSES.includes(status)) {
    return 'canceled';
  }

  if (PARTIAL_STATUSES.includes(status)) {
    return 'partial';
  }

  if (PENDING_STATUSES.includes(status)) {
    return 'pending';
  }

  return 'pending';
};

export const countInvoicesByStatus = (rows, statusKey) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  return safeRows.filter((row) => resolveInvoiceStatusCategory(row) === statusKey).length;
};

export const buildInvoiceStatusTabs = (rows, labels = {}) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const activeRows = safeRows.filter((row) => resolveInvoiceStatusCategory(row) !== 'canceled');

  return [
    { key: 'all', label: labels.all || 'Vigentes', count: activeRows.length, showCount: true },
    { key: 'pending', label: labels.pending || 'Pendientes', count: countInvoicesByStatus(safeRows, 'pending'), showCount: true },
    { key: 'partial', label: labels.partial || 'Parcialmente pagada', count: countInvoicesByStatus(safeRows, 'partial'), showCount: true },
    { key: 'paid', label: labels.paid || 'Pagadas', count: countInvoicesByStatus(safeRows, 'paid'), showCount: true },
    { key: 'canceled', label: labels.canceled || 'Canceladas', count: countInvoicesByStatus(safeRows, 'canceled'), showCount: true },
  ];
};

export const filterInvoicesByStatus = (rows, activeStatusTab) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  if (activeStatusTab === 'all') {
    return safeRows.filter((row) => resolveInvoiceStatusCategory(row) !== 'canceled');
  }

  return safeRows.filter((row) => resolveInvoiceStatusCategory(row) === activeStatusTab);
};
